import React, { useCallback, useEffect, useState } from "react";
import FullPageLoader from "@common/FullPageLoader";
import { Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getMasterConfigID } from "@store/slices/common";
import { useDispatch } from "react-redux";
import { useLanguage } from "@src/context/LanguageContext";

type faqProps = {};

const FaqList = (props: faqProps) => {

  const [loading, setLoading] = useState(false);
  const commonState = useSelector((state: any) => state.common);
  const [faqs,setFeaqs] = useState<any>(commonState?.common.faq)
  const dispatch: any = useDispatch();
  const {translations} = useLanguage();

  const fetchMasterConfig = useCallback(async () => {
    try {
      setLoading(true);
      const res: any = await dispatch(getMasterConfigID());
      if(res.status===200){
        setFeaqs(res.data.faq)
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch master config:", error);
    }
  }, [dispatch]);

    useEffect(() => {
      if (!commonState?.common || Object.keys(commonState.common).length === 0) {
        fetchMasterConfig();
      }
    }, [commonState?.common]);
   

  return (
    <React.Fragment>
      <FullPageLoader show={loading} />
      <div className="container-fluid">
        <div className="lead-top-heading p-lg-t">
          <h1>{translations?.DASHBOARD?.FAQ}</h1>
        </div>
    
        <div className="task-summery-outer bg-white quick-support-outer m-lg-t">
          <div className="row">
            <div className="col-md-12 w-100">
              <div className="summery-heading">
                {/* <h2>{translations?.DASHBOARD?.FAQ}</h2> */}
              </div>
          <div className="faq-wrapper faq-outer">
  <Accordion defaultActiveKey="0" className="accordian-outer config-accordain">
    {faqs?.map((item:any, index:number) => (
      <Accordion.Item eventKey={String(index)} key={index}>
        <Accordion.Header>
          {item.label}
          </Accordion.Header>
        <Accordion.Body>
          {item.value}
        </Accordion.Body>
      </Accordion.Item>
    ))}
  </Accordion>
</div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FaqList;
